import Quill from 'quill/core';
import { findQuillByNode } from '../../../../utils/findByNode';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const selectBlotAndWaitMagneticWallUpdate = (blot: any): Promise<void> =>
  new Promise((resolve) => {
    const quill = findQuillByNode(blot.scroll.domNode.parentNode);
    if (!quill) {
      resolve();
      return;
    }

    quill.root.focus({ preventScroll: true });
    quill.setSelection(blot.offset(quill.scroll), 1, Quill.sources.USER);

    // Wait for MagneticWall to reset highlighted thread to null
    // since we've changed the selection
    setTimeout(() => {
      resolve();
    }, 100);
  });

export default selectBlotAndWaitMagneticWallUpdate;
